import styled from 'styled-components';

export const Alert = styled.div`
  display: block;
  flex-grow: 1;
  width: 100%;
  place-self: unset;
  padding: 7px 12px;
  font-size: 13px;
  color: var(--carbone80);
  text-align: center;
  border-radius: 6px;
  margin-top: 20px;
  background: ${props =>
    props.error
      ? 'var(--red25)'
      : props.warning
      ? 'var(--yellow10)'
      : 'var(--white)'};
  margin-bottom: 1em;
`;
